import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_50b0t2xt: FaireBrandEntity = {
  token: "b_50b0t2xt",
  type: "brand",
  name: "Canyon Coffee",
  avatarUrl:
    "https://cdn.faire.com/fastly/f2438c4b705d9438c43674de2c69bda5b4a511c5f4949c114445b10b1d58f80e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f376745420e71c97f1f31ebedddbcedad391ab5aa06f32359d39598b65c04209.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f2438c4b705d9438c43674de2c69bda5b4a511c5f4949c114445b10b1d58f80e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f376745420e71c97f1f31ebedddbcedad391ab5aa06f32359d39598b65c04209.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 132,
  rating: 5,
  reviewCount: 28,
  isInsider: true,
  description:
    "We're Ally Walsh and Casey Wojtalewicz, and we met in Beachwood Canyon in Los Angeles. A model and musician, we fell in love with coffee together. In our travels for work, we would seek out the best local roasters to send beans home to each other, and we came to truly cherish the moments when we could enjoy our favorite morning ritual together—making coffee for each other.\n\nCasey started working in coffee as a barista, and became friends with James Klapp, a talented roaster. After a few years, it all culminated in the idea to turn our collective passion into something we could pour their love and energy into and share with the world. We decided to start Canyon Coffee in early 2016, and launched in October of that year with a pop-up at our friend Christy Dawn's shop in Venice, CA. \n\nWe began by sourcing exclusively organic coffee, with the goal of roasting to develop coffees that were naturally sweet, balanced, and caramelly, and easy to make taste great at home.",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:41.363Z",
    importedBy: "entity-db-cli",
  },
};
